document.querySelectorAll('.product-packs .product-pack').forEach(pack => {
    pack.addEventListener('click', function () {
      resetSelectedPack()
      pack.classList.add('selected');
      
      const productForm = document.querySelector(`form[data-type="add-to-cart-form"]`);
      if (!productForm) return;
      const addButton = productForm.querySelectorAll('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] span');

      if (!addButton) return;

      let addButtonString = window.variantStrings.addToCart + ` <span style="margin: 0 5px;">•</span> ${pack.dataset.price} <strike>${pack.dataset.comparePrice}</strike>`;
      
      if(pack.dataset.comparePrice === pack.dataset.price) {
        addButtonString = window.variantStrings.addToCart + ` <span style="margin: 0 5px;">•</span> ${pack.dataset.price}`;
      }

      addButtonText.innerHTML = addButtonString;

      document.querySelector('input[name=quantity].quantity__input').value = pack.dataset.quantity;
      
    })
  })
  
  function resetSelectedPack() {
    document.querySelectorAll('.product-packs .product-pack').forEach(pack => {
      pack.classList.remove('selected');
    })
  }